import React, { useEffect } from 'react'
import '../../components/Header.css'
import '../../pages/Notebook/Notebook.css'
import ScrollToTop from '../../components/ScrollToTop'

export default function Notebook(props) {
  useEffect(() => {
    document.title='Notebook | UCopenhagen'
  }, []);

    return(
      <div className='notebook-container'>
        <div className='team-picture'>
            <img src='https://static.igem.wiki/teams/4247/wiki/backgrounds/8.svg' alt=''/></div>

        <div className ="box-exp-intro">
            <br></br>
            <p style={{color:'white', margin:'auto 2% auto 2%', display:'block'}}><b>In order to properly understand the daily progress of Netlantis team's scientific work and to carry out an exhaustive analysis of the results, the most significant experiments and results were carefully collected in a physical notebook in the laboratory and then transferred to a digital notebook, which is the one presented <a href='https://static.igem.wiki/teams/4247/wiki/lab-log-2022-04-19-2022-10-05-etr-agi7l1wl-compressed.pdf' className='page-links' style={{color:'#fff'}} target='_blank' rel='noreferrer'>here.</a></b></p>
            <br></br>
            </div>
        <div className='notebook-content'>



          <br></br>
          <div style={{display:'flex', height:'1000px'}}>
          <iframe src={`${'https://static.igem.wiki/teams/4247/wiki/lab-log-2022-04-19-2022-10-05-etr-agi7l1wl-compressed.pdf'}#view=fitH`} title='CVD Cookbook' frameBorder="0" scrolling="auto" height="100%" width="100%"></iframe>
          </div>
        </div>
      <ScrollToTop/>
      </div>
    )
}